import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

import { verificaAccesoriosV2 } from "../repository";
import { getAccesorioSticker } from "./accesoriosSticker";

const ProductImageZoomViewer = (props) => {
  // Si el padre ya verificó accesorios, usa esa prop y evita una llamada extra.
  // Solo consulta por su cuenta cuando la prop no viene definida.
  const stickerFromProp = typeof props.stickerTipo === "string";
  const [stickerTipo, setStickerTipo] = useState(
    stickerFromProp ? props.stickerTipo : "NINGUNO"
  );

  useEffect(() => {
    const codigo = props.item.Codigo;
    if (stickerFromProp || !codigo) return;

    let cancelado = false;
    verificaAccesoriosV2(codigo)
      .then((response) => {
        // Fallo silencioso: si no es éxito, simplemente no se muestra el sticker.
        if (!cancelado && response.status === "success") {
          setStickerTipo((response.result && response.result.stickerTipo) || "NINGUNO");
        }
      })
      .catch(() => {
        // El sticker es informativo; un error no debe romper el zoom.
      });

    return () => {
      cancelado = true;
    };
  }, [props.item.Codigo, stickerFromProp]);

  const sticker = getAccesorioSticker(stickerTipo);

  const handleBackdropClick = (e) => {
    // Solo cerrar si se hace clic en el backdrop, no en el contenido
    if (e.target === e.currentTarget) {
      props.closeModal();
    }
  };

  // Usar Portal para renderizar el modal fuera del card
  return ReactDOM.createPortal(
    <div className="image-zoom-overlay" onClick={handleBackdropClick}>
      <div className="image-zoom-modal">
        <div className="image-zoom-header">
          <h5 className="image-zoom-title">
            {props.item.Familia} {props.item.Codigo} (Zoom)
          </h5>
          <button
            type="button"
            className="image-zoom-close"
            onClick={props.closeModal}
            aria-label="Cerrar"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="image-zoom-body">
          {sticker && (
            <img
              alt={sticker.alt}
              src={sticker.src}
              className="accesorios-badge"
            />
          )}
          <img
            alt={props.item.Codigo}
            src={props.imageSource}
            className="image-zoom-img"
          />
        </div>
        <div className="image-zoom-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={props.closeModal}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ProductImageZoomViewer;
